import React from 'react';
import BinSVG from 'src/assets/svg/bin-v2.svg';
import { Button } from 'src/components';

const DeleteFeedbackButton = ({ onClick }) => (
  <Button
    onClick={onClick}
    type='button'
    variant='custom'
    className='flex items-center border border-hover-red text-hover-red bg-white hover:bg-red-warning px-3 py-2 rounded-md transition-colors duration-300 focus:outline-none justify-center gap-2'
  >
    <BinSVG className='text-hover-red' />
    <span className='text-base font-bold'>Delete</span>
  </Button>
);
export default DeleteFeedbackButton;
